import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../cmsConfig';
import { CreateMeetingModel } from '../../types/Meetings/CreateMeetingModel';
import { CoachAppointment } from '../../types/Meetings/CoachMeeting';
export interface ReactConfig {
  applicationInsightsConnectionString: string;
}

export const reportMeetingApi = createApi({
  reducerPath: 'reportMeetingApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${cmsApiConfig.url}/portalapi/meetings`,
    headers: {
      'X-CSRF': '1',
    },
    credentials: 'include',
  }),
  tagTypes: ['Meetings'],
  endpoints: (builder) => ({
    getMeetings: builder.query<CoachAppointment[], string>({
      query: (id) => ({
        url: `?participantId=${id}`,
      }),
      providesTags: ['Meetings'],
    }),
    addMeeting: builder.mutation<void, {id: string, newMeeting: CreateMeetingModel}>({
      query: ({id, newMeeting}) => ({
        url: `?participantId=${id}`,
        method: 'POST',
        body: newMeeting,
      }),
      invalidatesTags: ['Meetings'],
    }),
    updateMeeting: builder.mutation<
      void,
      { participantId: string, appointmentId: string, updatedMeeting: CreateMeetingModel }
    >({
      query: ({ participantId, appointmentId, updatedMeeting }) => ({
        url: `?participantId=${participantId}&appointmentId=${appointmentId}`,
        method: 'PUT',
        body: updatedMeeting,
      }),
      invalidatesTags: ['Meetings'],
    }),
    deleteMeeting: builder.mutation<void, string>({
      query: (id) => ({
        url: `?appointmentId=${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Meetings'],
    }),
  }),
});

export const {
  useGetMeetingsQuery,
  useAddMeetingMutation,
  useUpdateMeetingMutation,
  useDeleteMeetingMutation,
  useLazyGetMeetingsQuery,
} = reportMeetingApi;
